import React, { useEffect } from "react";
import { Box, Flex, Button, Image, Spacer } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import kiido from "../assets/images/kiido.svg";
import CookieConsent from "./CookieConsent";

const NavBar = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    const consent = Cookies.get("cookie_consent");
    if (consent) {
      Cookies.set("preferred_language", lng, { expires: 365 });
    }
  };

  useEffect(() => {
    const savedLanguage = Cookies.get("preferred_language");
    const consent = Cookies.get("cookie_consent");
    if (savedLanguage && consent) {
      i18n.changeLanguage(savedLanguage);
    } else {
      i18n.changeLanguage("fr"); // Set default language to French
      if (consent) {
        Cookies.set("preferred_language", "fr", { expires: 365 });
      }
    }
  }, [i18n]);

  return (
    <>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        padding="1rem 1.5rem"
        bg="white"
        color="black"
        borderBottom="1px solid"
        borderColor="gray.200"
        boxShadow="0 4px 4px 0 rgba(0, 0, 0, 0.25)"
        flexDirection={{ base: "row", md: "row" }} // Consistent row layout
      >
        {/* Logo Section */}
        <Flex
          align="center"
          justify="flex-start"
          width={{ base: "50%", md: "auto" }}
        >
          <a href="https://kiido.fr/appointments">
          <Image
            src={kiido}
            alt={t("navbar.kiido")}
            boxSize={{ base: "80px", md: "123px" }}
            height={{ base: "40px", md: "48px" }}
            mr={{ base: 0, md: 14 }}
          />
          </a>
        </Flex>

        {/* Spacer only for desktop */}
        <Spacer display={{ base: "none", md: "block" }} />

        {/* Language Selector Section */}
        <Box
          display="flex"
          justifyContent={{ base: "flex-end", md: "flex-end" }}
          width={{ base: "50%", md: "auto" }}
        >
          <Button
            backgroundColor={i18n.language === "fr" ? "#FF6666" : "white"}
            color={i18n.language === "fr" ? "white" : "#FF6666"}
            mr={2}
            _hover={{ bg: "#FF4C4C", color: "white" }}
            width="33px"
            height="28px"
            padding="0"
            onClick={() => changeLanguage("fr")}
          >
            {t("navbar.language_fr")}
          </Button>
          <Button
            backgroundColor={i18n.language === "en" ? "#FF6666" : "white"}
            color={i18n.language === "en" ? "white" : "#FF6666"}
            _hover={{ bg: "#FF4C4C", color: "white" }}
            width="33px"
            height="28px"
            padding="0"
            onClick={() => changeLanguage("en")}
          >
            {t("navbar.language_en")}
          </Button>
        </Box>
      </Flex>

      <CookieConsent />
    </>
  );
};

export default NavBar;
